import type { ComponentProps } from "react";
import { forwardRef } from "react";
import { Animated } from "react-native";
import { Circle } from "react-native-svg";

type CircleProps = ComponentProps<typeof Circle> & { collapsable?: boolean };

/**
 * Animated forces `collapsable={false}` on the wrapped component, and
 * react-native-svg forwards it to the DOM `<circle>` on web, triggering a
 * non-boolean attribute warning. Strip it before it reaches Circle.
 */
const CollapsableSafeCircle = forwardRef<Circle, CircleProps>(
	({ collapsable: _collapsable, ...props }, ref) => (
		<Circle ref={ref} {...props} />
	),
);

export const AnimatedSvgCircle = Animated.createAnimatedComponent(
	CollapsableSafeCircle,
);
